import { render, staticRenderFns } from "./VideoArchivedAddEditModal.vue?vue&type=template&id=f7f7af00&"
import script from "./VideoArchivedAddEditModal.vue?vue&type=script&lang=js&"
export * from "./VideoArchivedAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports